<template>
  <div>
    <v-card class="unauthorized-card d-flex justify-center align-center flex-column">
      <v-icon color="#0f426ec3" class="px-1" size="120">mdi-lock</v-icon>
      <div class="main-message mb-2 my-4">Acesso negado</div>
      <span class="info-message"
        >Desculpe, você não tem permissão para acessar esta página, clique <span @click="redirect">aqui</span> para
        voltar
      </span>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('LoginStore', ['logged', 'user'])
  },
  methods: {
    redirect() {
      const { userToken } = this.user;
      const [role] = userToken.claims;
      const roleValue = role.value;
      if (roleValue === 'Admin') {
        this.$router.push('/users');
      } else if (roleValue === 'Operador') {
        this.$router.push('/couriers');
      } else if (roleValue === 'Embarcador') {
        this.$router.push('/shipper-deliveries');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.unauthorized-card {
  height: calc(100vh - 190px);
  position: relative;
}
.main-message {
  font-size: 2.2rem;
  font-weight: 500;
  color: #0f426ec3;
}
.info-message {
  font-size: 1.1rem;
  font-weight: 500;
  color: #0f426ec3;
}

.info-message span {
  font-size: 1.2rem;
  font-weight: 500;
  color: #2e9dffc3;
  cursor: pointer;
  &:hover {
    color: #0088ffe4;
  }
}
</style>
